import { BroadcastChannel } from 'broadcast-channel';

interface SignInMessage {
  /**
   * 登陆
   */
  type: 'signIn';

  /**
   * accessToken
   */
  params: string;
}

interface SignOutMessage {
  /**
   * 登出
   */
  type: 'signOut';
  params?: unknown;
}

interface PayCompleteMessage {
  /**
   * 订阅页面支付完成消息
   */
  type: 'payComplete';

  /**
   * 支付状态
   */
  params: any;
}

type Message = SignInMessage | SignOutMessage | PayCompleteMessage;

type MessageType = Message['type'];

type MessageParams<T extends MessageType> = Extract<Message, { type: T; }>['params'];

type Listener<T> = T extends MessageType ? (params: MessageParams<T>) => void : (data: any) => void;

let channel: BroadcastChannel<Message> | null = null;

const listeners = new Map<MessageType, Set<Listener<MessageType>>>();

if (typeof window !== 'undefined') {
  if (!channel) { channel = new BroadcastChannel<Message>('roboneo-web'); }
  if (channel) {
    channel.addEventListener('message', (data: Message) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      listeners.get(data.type)?.forEach((listener) => listener(data.params));
    });
  }
}

/**
 *  添加 Broadcast 监听
 *
 *  @param type 消息类型
 */
export function addBroadcastListener<T extends MessageType>(type: T, listener: Listener<T>) {
  if (listeners.has(type)) {
    listeners.get(type)?.add(listener);
  } else {
    listeners.set(type, new Set([listener]));
  }

  return () => {
    removeBroadcastListener(type, listener);
  };
}

/**
 *  移除 Broadcast 监听
 *
 *  @param type 消息类型
 *  @param listener
 */
export function removeBroadcastListener<T extends MessageType>(type: T, listener: Listener<T>) {
  if (listeners.has(type)) {
    listeners.get(type)?.delete(listener);
  }
}

/**
 *  发送 Broadcast 消息
 */
export function sendBroadcastMessage(message: Message) {
  console.log('sendBroadcastMessage-----', message.type);
  channel?.postMessage(message);
}
